import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable()
export class CompanyTeamsService {
  idgDataUrl: string;

  constructor(public http: HttpClient, private config: ConfigurationService) {
    this.idgDataUrl = config.resolveIdgUrl();
  }

  getCompanyTeams(
    page: number,
    searchBy: string,
    searchInput: string,
    sort: string,
    pageSize: number = 7
  ) {
    const by = searchBy || "team";
    const name = searchInput || "";
    return this.http.get(
      `${this.idgDataUrl}/company-resources/teams/filter?by=${by}&name=${name}&sort=${sort}&page=${page}&size=${pageSize}`
    );
  }

  getCompanyTeamsByToggle(
    page: number,
    searchBy: string,
    searchInput: string,
    sort: string,
    pageSize: number,
    palliativeCareTeamToggle: boolean = false
  ) {
    const by = searchBy || "team";
    const name = searchInput || "";
    return this.http.get(
      `${this.idgDataUrl}/company-resources/teams/filter?by=${by}&name=${name}&sort=${sort}&page=${page}&size=${pageSize}&palliativeCareTeamToggle=${palliativeCareTeamToggle}`
    );
  }

  getUserTeams() {
    // not used
    return this.http.get(`${this.idgDataUrl}/company-resources/userTeams`);
  }

  getTeamMembersByTeamId(teamId) {
    // not used
    return this.http.get(
      `${this.idgDataUrl}/company-resources/userTeams/${teamId}/members`
    );
  }

  /**
   * OPS-2873. The single company-level Multi-Site Team for the org the user is switched into,
   * or an empty body when none has been created yet.
   *
   * Deliberately NOT /teams/filter: that is a paged grid keyed on a required `by` search mode,
   * and this is a 0-or-1 resource. The backend also EXCLUDES MTEAM from /teams/filter so the
   * Location Teams and Company Teams grids cannot rename or delete it.
   */
  getMultiSiteTeam() {
    return this.http.get(
      `${this.idgDataUrl}/company-resources/teams/multi-site`
    );
  }

  getCompanyTeamRoles() {
    return this.http.get(`${this.idgDataUrl}/company-resources/roles?type=H`);
  }

  getCompanyTeamPatients(teamId, page, sort: string, pageSize: number = 8) {
    return this.http.get(
      `${this.idgDataUrl}/company-resources/teams/${teamId}/patients?patientStatus=On-Service&sort=${sort}&page=${page}&size=${pageSize}`
    );
  }

  getCompanyTeam(teamId) {
    // not used
    return this.http.get(
      `${this.idgDataUrl}/company-resources/teams/${teamId}`
    );
  }

  getCompanyTeamMemberByRole(roleId, size) {
    return this.http.get(
      `${this.idgDataUrl}/company-resources/persons/role/${roleId}?size=${size}`
    );
  }

  checkCompanyTeamsExists(name: string) {
    return this.http.get(
      `${this.idgDataUrl}/company-resources/teams/exists?name=${name}`
    );
  }

  postCompanyTeam(data: any) {
    return this.http.post(`${this.idgDataUrl}/company-resources/teams`, data);
  }

  putCompanyTeam(data: any) {
    return this.http.put(`${this.idgDataUrl}/company-resources/teams`, data);
  }

  deleteCompanyTeam(teamId) {
    return this.http.delete(
      `${this.idgDataUrl}/company-resources/teams/${teamId}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/company-teams-service/company-teams-service.ts